var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCartHeader = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 79,
  height: 83,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#19AD78",
  fillRule: "evenodd",
  stroke: "#19AD78",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M22.447 81.162h34.379c12.628 0 22.316-4.561 19.564-22.919l-3.204-24.88c-1.697-9.16-7.54-12.665-12.666-12.665H18.602c-5.202 0-10.705 3.77-12.666 12.666L2.732 58.243C.395 74.528 9.82 81.162 22.447 81.162",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#19AD78",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M21.882 19.793C21.882 9.966 29.847 2 39.674 2v0a17.79 17.79 0 0 1 17.868 17.793v0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M27.46 38.34h.188z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M27.46 38.34h.188"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M51.473 38.34h.189z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M51.473 38.34h.189"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 3,
  d: "M27 49.348c0 5.849 5.586 10.59 12.476 10.59s12.476-4.741 12.476-10.59"
})));
export default SvgCartHeader;